var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-tag",class:`status-${_vm.tone}`},[_c('i'),_vm._v(_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }